<div class="container-fluid member-section p-4 rounded-4 mt-4 position-relative">
  <h4 class="section-heading mb-4">
    <i class="bi bi-people me-2"></i>Class Members
  </h4>
  <ng-container *ngIf="isLoading; else pageContent">
<div class="app-spinner">
	<mat-spinner></mat-spinner>
</div>
</ng-container>

<ng-template #pageContent>
  <div class="d-flex justify-content-between align-items-center mb-3 position-relative">
    <h5 class="role-title">Teachers</h5>
  </div>
  <div class="row mb-4">
	  <ng-container *ngIf="_teachers.length >0 ; else noTeachers">
    <div class="col-md-6 mb-3" *ngFor="let teacher of _teachers">
      <div class="member-card d-flex align-items-center p-3">
        <div class="avatar-box me-3">{{teacher.first_name[0]}}{{teacher.last_name[0]}}</div>
        <div class="flex-grow-1">
          <strong class="member-name">{{teacher.first_name}} {{teacher.last_name}}</strong>
          <div class="member-email">{{teacher.phone_email}}</div>
        </div>
        <ng-container *ngIf="teacher.owner; else teacherLabel">
          <span class="badge role-badge owner-badge">Owner</span>
        </ng-container>
        <ng-template #teacherLabel>
          <span class="badge role-badge owner-badge">Teacher</span>
        </ng-template>
      </div>
    </div>
	</ng-container>
	<ng-template #noTeachers>
<p>No Teachers Found</p>
	</ng-template>
  </div>
</ng-template>

  <div class="d-flex justify-content-between align-items-center mb-3 position-relative">
    <h5 class="role-title">Students</h5>
  </div>
  <div class="row">
		  <ng-container *ngIf="_students.length >0 ; else noStudents">
    <div class="col-md-6 mb-3" *ngFor="let student of _students">
      <div class="member-card d-flex align-items-center p-3">
        <div class="avatar-box me-3">{{student.first_name[0]}}{{student.last_name[0]}}</div>
        <div class="flex-grow-1">
          <strong class="member-name">{{student.first_name}} {{student.last_name}}</strong>
          <div class="member-email">{{student.phone_email}}</div>
        </div>
        <span class="badge role-badge student-badge">Student</span>
      </div>
    </div>
	</ng-container>
	<ng-template #noStudents>
	<p>No Students Found</p>
	</ng-template>
  </div>
</div>